/* eslint-disable */

import { useEffect, useState } from "react";

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import { fetchGraphQL } from "../../../services/api-raindrop.js";
import OrganisationLogo from "../../../ui-components/organisation-logo/organisation-logo";
import { useNavigate, useParams } from "react-router-dom";
import WaterfallIcon from "../../../ui-components/waterfall-icon/waterfall-icon.tsx";

import WaterfallActivity from "../../../ui-components/waterfall-activity/waterfall-activity.tsx";

import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider.js";
import AccountAvatar from "../../../ui-components/account-avatar/account-avatar.tsx";
import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element.js";
import RaindropCircle from "../../../ui-components/raindrop-circle/raindrop-circle.tsx";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";

import { Color, Size } from "../../../logic/enums.ts";
import RaindropClickable from "../../../ui-components/raindrop-clickable/raindrop-clickable.tsx";
import RaindropHeading from "../../../ui-components/raindrop-heading/raindrop-heading.tsx";
import RaindropMotionFadeUp from "../../../ui-components/raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";

import ContributionSlider from "../../../ui-components/contribution-slider/contribution-slider.tsx";
import RaindropBackButtonPanel from "../../../ui-components/raindrop-back-button-panel/raindrop-back-button-panel.tsx";
import RaindropTextParagraph from "../../../ui-components/raindrop-text-paragraph/raindrop-text-paragraph.tsx";
import RaindropTextSubtitle from "../../../ui-components/raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import RaindropTextHeading1 from "../../../ui-components/raindrop-text-heading-1/raindrop-text-heading-1.tsx";

import Currency from "../../../ui-components/currency/currency.tsx";
import RaindropPinnedToBottom from "../../../ui-components/raindrop-pinned-to-bottom/raindrop-pinned-to-bottom.tsx";
import Spacer from "../../../ui-components/spacer/spacer.js";
import FlexRow from "../../../ui-components/flex-row/flex-row.tsx";
import FlexCol from "../../../ui-components/flex-col/flex-col.tsx";
import RaindropProgressBar from "../../../ui-components/raindrop-progress-bar/raindrop-progress-bar.tsx";
import RaindropInfoBox from "../../../ui-components/raindrop-info-box/raindrop-info-box.tsx";

type Waterfall = {
  id: string;

  title: string;
  summary: string;

  organisationId: string;
  organisationName: string;
  organisationPresignedUrl: string;

  accountId: string;
  accountPresignedUrl: string;

  posts: WaterfallPost[];
};

type WaterfallPost = {
  id: string;
  text: string;
  presignedUrl: string;
};

enum WaterfallLevel {
  Basic = 0,
  Bronze = 1,
  Silver = 2,
  Gold = 3,
  Diamond = 4,
}

const ModalCascade = ({
  urlOrganisation,
  urlUser,
  username,
  title,
  accountId,
  waterfallId,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const onCascadeConfirm = () => {
    console.log("Cascade confirmed");
    setIsLoading(true);

    fetchGraphQL(`
      mutation {
        waterfallCascade(
          accountId: "${accountId}",
          waterfallId: "${waterfallId}"
        ) {
          id
        }
      }
    `).then((result) => {
      console.log("🔴 (RS-032) - ", result);
      setIsLoading(false);
      navigate(`/raindrop/waterfall/${result.data.waterfallCascade.id}`);
    });
  };

  return (
    <div className="flex flex-col gap-8 justify-center items-center">
      <WaterfallIcon
        username={username}
        isLarge={true}
        urlOrganisation={urlOrganisation}
        urlUser={urlUser}
      />
      <h2 className="font-bold text-lg">{title}</h2>
      <RaindropDivider />
      <p className="text-left text-color-dark-text-secondary">
        Cascading a waterfall will create your own Waterfall with the same title
        so you can join in raising money for important causes.
      </p>
      <RaindropButton
        title="Confirm"
        onClick={onCascadeConfirm}
        isFluid={true}
        size={Size.Large}
        style={ButtonStyle.Primary}
      />
    </div>
  );
};

const SectionCrest = ({
  urlOrganisation,
  urlUser,
  username,
  waterfallTitle,
  crestWaterfallId,
}) => {
  const navigate = useNavigate();
  return (
    <RaindropClickable
      onClick={() => navigate(`/raindrop/waterfall/${crestWaterfallId}`)}
    >
      <RaindropCard>
        <RaindropHeading title="Cascaded from" style={ButtonStyle.Secondary} />

        <div className="flex flex-row gap-3 items-center w-full">
          <WaterfallIcon
            urlUser={urlUser}
            username={username}
            urlOrganisation={urlOrganisation}
          />

          <div className="text-left">
            <p className="font-black">{waterfallTitle}</p>
            <p className="font-bold dark:text-color-dark-text-secondary text-color-text-secondary">
              {username}
            </p>
          </div>
          <i className="fa fa-chevron-right ml-auto text-color-dark-text-secondary" />
        </div>
      </RaindropCard>
    </RaindropClickable>
  );
};

const WaterfallAboutSection = ({
  waterfall,
  onAddNewOrganisation = (args) => {},
  onCancelOrganisation = (args) => {},
  isSupporting = false,
}) => {
  return (
    <RaindropMotionFadeUp>
      <div className="flex flex-row gap-4 w-full items-center">
        <WaterfallIcon
          isHuge={true}
          urlUser={waterfall.account.presignedUrl}
          username={waterfall.account.username}
          urlOrganisation={waterfall.organisation.presignedUrlLogo}
        />
        <div className="flex flex-col gap-4 w-full text-left">
          <div>
            <h1 className="font-bold text-color-text-secondary dark:text-color-dark-text-secondary">
              Waterfall
            </h1>
            <div className="font-black text-lg dark:text-color-dark-text-primary text-color-text-primary">
              {waterfall.title}
            </div>
          </div>

          <FlexRow>
            {!isSupporting && (
              <RaindropButton
                title="Give"
                style={ButtonStyle.Outline}
                onClick={() => onAddNewOrganisation({ waterfall: waterfall })}
              />
            )}
            {isSupporting && (
              <RaindropButton
                title="Pause support"
                style={ButtonStyle.Secondary}
                onClick={() => onCancelOrganisation({ waterfall: waterfall })}
              />
            )}
            <RaindropButton
              icon="fa-arrow-up-from-bracket"
              style={ButtonStyle.Icon}
              size={Size.Large}
            />
          </FlexRow>
        </div>
      </div>
    </RaindropMotionFadeUp>
  );
};

const WaterfallAccountAndOrganisation = ({
  accountId,
  accountPresignedUrl,
  accountUsername,
  organisationId,
  organisationName,
  organisationPresignedUrl,
}) => {
  const navigate = useNavigate();
  return (
    <RaindropCard>
      <div className="flex flex-col gap-4 w-full text-left">
        <RaindropClickable
          onClick={() => {
            navigate(`/raindrop/organisation/${organisationId}`);
          }}
          additionalClasses="w-full text-left"
        >
          <div className="flex flex-row gap-4 w-full  ">
            <OrganisationLogo src={organisationPresignedUrl} />
            <div className="flex flex-col">
              <h1 className="text-xs font-bold text-color-dark-text-secondary">
                Organisation
              </h1>
              <h1 className="font-bold text-lg">{organisationName}</h1>
            </div>
          </div>
        </RaindropClickable>

        <RaindropClickable
          onClick={() => {
            navigate(`/raindrop/account/${accountId}`);
          }}
          additionalClasses="w-full "
        >
          <div className="flex flex-row gap-4 w-full ">
            <AccountAvatar
              presignedUrl={accountPresignedUrl}
              username={accountUsername}
            />
            <div>
              <h4 className="text-xs font-bold text-color-dark-text-secondary">
                Account
              </h4>
              <p className="font-bold text-lg">{accountUsername}</p>
            </div>
          </div>
        </RaindropClickable>
      </div>
    </RaindropCard>
  );
};

const WaterfallInfoSection = ({
  supporterCount,
  postsLength,
  cascadeCount,
}) => {
  return (
    <FlexRow className="px-4" tailwindGap="gap-4">
      <RaindropInfoBox title={"Supporters"} value={supporterCount} />
      <RaindropInfoBox title={"Posts"} value={postsLength} />
      <RaindropInfoBox title={"Cascades"} value={cascadeCount} />
    </FlexRow>
  );
};

const WaterfallSummary = ({
  waterfall,
  isYourWaterfall = false,
  onCascade = () => {},
}) => {
  return (
    <RaindropCard>
      <FlexCol tailwindGap="gap-1">
        <RaindropHeading title="Here's how" isSecondary={true} />
        <RaindropTextParagraph>
          {waterfall.summary || waterfall.waterfallCrest?.summary}
        </RaindropTextParagraph>
        {waterfall.waterfallCrest && (
          <RaindropTextSubtitle>
            This is a cascaded waterfall
          </RaindropTextSubtitle>
        )}

        {!isYourWaterfall && (
          <FlexRow className="flex-row-reverse">
            <RaindropButton
              title="Cascade"
              icon="fa-clone"
              onClick={onCascade}
              style={ButtonStyle.Outline}
            />
          </FlexRow>
        )}
      </FlexCol>
    </RaindropCard>
  );
};

const WaterfallLevelProgressBarComponent = ({
  waterfallLevel = WaterfallLevel.Basic,
  progressProportion = 0.4,
  subunits,
  isYourWaterfall = true,
}) => {
  let title = "Basic Waterfall";
  let subtitle = "Keep supporting to reach the Bronze Waterfall";
  let progressColor = Color.Blue;

  progressProportion = Math.min(1, progressProportion);
  progressProportion = Math.max(0, progressProportion);

  if (waterfallLevel === WaterfallLevel.Bronze) {
    title = "Bronze Waterfall";
    subtitle = "Keep supporting to reach the Silver Waterfall";
    progressColor = Color.Bronze;
  }
  if (waterfallLevel === WaterfallLevel.Silver) {
    title = "Silver Waterfall";
    subtitle = "Keep supporting to reach the Gold Waterfall";
    progressColor = Color.Silver;
  }
  if (waterfallLevel === WaterfallLevel.Gold) {
    title = "Gold Waterfall";
    subtitle = "You're incredible!";
    progressColor = Color.Gold;
  }

  return (
    <div className="flex flex-col gap-4 w-full ">
      <div className="flex flex-row gap-2 w-full items-center justify-between ">
        <RaindropTextHeading1>{title}</RaindropTextHeading1>
        {isYourWaterfall && (
          <div className="flex flex-row gap-2 items-center">
            <RaindropTextSubtitle>
              <Currency currency="GBP" subunits={subunits} />
            </RaindropTextSubtitle>
            <RaindropTextSubtitle>
              <i className="fa fa-info-circle " />
            </RaindropTextSubtitle>
          </div>
        )}
      </div>

      <RaindropProgressBar
        proportion={progressProportion}
        color={progressColor}
      />
      <RaindropTextSubtitle>{subtitle}</RaindropTextSubtitle>
    </div>
  );
};

const WaterfallLevelAwardComponent = ({ waterfallLevel }) => {
  let tailwindBackgroundColor = "bg-yellow-600";
  let tailwindTextColor = "text-yellow-600";
  let tailwindBorderColor = "border-yellow-600";

  if (waterfallLevel === WaterfallLevel.Basic) {
    tailwindBackgroundColor = "bg-blue-300";
    tailwindTextColor = "text-blue-300";
    tailwindBorderColor = "border-blue-300";
  }

  if (waterfallLevel === WaterfallLevel.Bronze) {
    tailwindBackgroundColor = "bg-amber-600";
    tailwindTextColor = "text-amber-600";
  }

  if (waterfallLevel === WaterfallLevel.Silver) {
    tailwindBackgroundColor = "bg-slate-200";
    tailwindTextColor = "text-slate-200";
  }

  if (waterfallLevel === WaterfallLevel.Gold) {
    tailwindBackgroundColor = "bg-amber-400";
    tailwindTextColor = "text-amber-400";
  }

  return (
    <div
      className={`flex flex-col items-center justify-center gap-2  bg-opacity-25 p-4 w-[100px] min-h-[100px] rounded-lg border-4 ${tailwindBackgroundColor} ${tailwindTextColor} ${tailwindBorderColor}`}
    >
      <i className={"fa fa-trophy  text-5xl "} />
    </div>
  );
};

const WaterfallGoalSection = ({
  subunits = 10_00,
  isYourWaterfall = false,
}) => {
  let waterfallLevel = WaterfallLevel.Basic;
  let subunitsThreshold = 10_00;
  if (subunits >= 10_00) {
    waterfallLevel = WaterfallLevel.Bronze;
    subunitsThreshold = 30_00;
  }
  if (subunits >= 30_00) {
    waterfallLevel = WaterfallLevel.Silver;
    subunitsThreshold = 100_00;
  }
  if (subunits >= 100_00) {
    waterfallLevel = WaterfallLevel.Gold;
    subunitsThreshold = 300_00;
  }
  // if (subunits >= 300_00) {
  //   waterfallLevel = WaterfallLevel.Diamond;
  //   subunitsThreshold = 300_00;
  // }

  return (
    <RaindropCard>
      <FlexRow className="gap-4">
        <WaterfallLevelAwardComponent waterfallLevel={waterfallLevel} />
        <WaterfallLevelProgressBarComponent
          subunits={subunits}
          progressProportion={subunits / subunitsThreshold}
          isYourWaterfall={isYourWaterfall}
          waterfallLevel={waterfallLevel}
        />
      </FlexRow>
    </RaindropCard>
  );
};

const WaterfallPostsSection = ({ waterfall }) => {
  if (waterfall.posts.length === 0) {
    return (
      <RaindropTextSubtitle>
        This Waterfall has no posts yet
      </RaindropTextSubtitle>
    );
  }

  return (
    <FlexCol className="gap-6">
      <RaindropTextHeading1>Posts</RaindropTextHeading1>
      <FlexCol>
        {waterfall.posts.map((post, index) => (
          <RaindropMotionFadeUp key={index} delay={index * 0.2}>
            <WaterfallActivity
              key={post.id}
              waterfallId={waterfall.id}
              isLinkToWaterfall={false}
              waterfallTitle={waterfall.title}
              urlUser={waterfall.account.presignedUrl}
              urlOrganisation={waterfall.organisation.presignedUrlLogo}
              activityDescription={post.text}
              urlActivity={post.mediaObjects[0].presignedUrl}
              createdAt={post.createdAt}
              accountObjectsLiked={post.accountObjectsLiked}
              username={waterfall.account.username}
            />
          </RaindropMotionFadeUp>
        ))}
      </FlexCol>
    </FlexCol>
  );
};

const ContentWaterfall = ({
  waterfall,
  userCurrent,
  onAddNewOrganisation = (args) => {},
  onCancelOrganisation = (args) => {},
  setCurrentModalComponent = (args) => {},
  isYourWaterfall = false,
  values = [],
  setValues = (args) => {},
}) => {
  if (waterfall === undefined || waterfall === null) {
    return <RaindropLoadingElement isShnoodle={true} />;
  }

  const onCascade = () => {
    setCurrentModalComponent(
      <ModalCascade
        title={waterfall.title}
        urlOrganisation={waterfall.organisation.presignedUrlLogo}
        urlUser={userCurrent.account.presignedUrl}
        accountId={userCurrent.account.id}
        waterfallId={waterfall.id}
      />
    );
  };

  const isSupporting = values.find((v) => {
    return v.waterfall?.id === waterfall.id;
  });

  const activeSausage = values.find((v) => {
    return v.waterfall?.id === waterfall.id;
  });

  return (
    <div className="flex w-full flex-col gap-6 ">
      <RaindropMotionFadeUp>
        <div className="flex flex-col w-full text-left gap-6 ">
          <WaterfallAboutSection
            waterfall={waterfall}
            onAddNewOrganisation={onAddNewOrganisation}
            onCancelOrganisation={onCancelOrganisation}
            isSupporting={isSupporting}
          />

          <ContributionSlider
            sausageValue={activeSausage}
            sausageValues={values}
            setValues={setValues}
          />
          <WaterfallSummary
            waterfall={waterfall}
            isYourWaterfall={isYourWaterfall}
            onCascade={onCascade}
          />

          <WaterfallInfoSection
            supporterCount={waterfall.supporterCount}
            postsLength={waterfall.posts.length}
            cascadeCount={waterfall.cascadeCount}
          />

          <WaterfallGoalSection
            subunits={waterfall.subunits}
            isYourWaterfall={isYourWaterfall}
          />

          <WaterfallAccountAndOrganisation
            accountId={waterfall.account.id}
            accountPresignedUrl={waterfall.account.presignedUrl}
            accountUsername={waterfall.account.username}
            organisationId={waterfall.organisation.id}
            organisationName={waterfall.organisation.name}
            organisationPresignedUrl={waterfall.organisation.presignedUrlLogo}
          />

          {waterfall.waterfallCrest && (
            <SectionCrest
              urlOrganisation={
                waterfall.waterfallCrest.organisation.presignedUrlLogo
              }
              urlUser={waterfall.waterfallCrest.account.presignedUrl}
              username={waterfall.waterfallCrest.account.username}
              crestWaterfallId={waterfall.waterfallCrest.id}
              waterfallTitle={waterfall.title}
            />
          )}
        </div>
      </RaindropMotionFadeUp>
      <WaterfallPostsSection waterfall={waterfall} />
    </div>
  );
};

const RaindropWaterfall = ({
  userCurrent,
  values,
  setValues,
  onAddNewOrganisation,
  onCancelOrganisation,
  setCurrentModalComponent,
}) => {
  const { waterfallId } = useParams();

  const [waterfall, setWaterfall] = useState<Waterfall | null>(null);

  const isYourWaterfall = waterfall?.account.id === userCurrent?.account.id;

  // Fetch waterfall data
  useEffect(() => {
    fetchGraphQL(`
      query {
        waterfall(id: "${waterfallId}") {
          id
          title
          summary
          createdAt
          supporterCount
          cascadeCount
          subunits
          subunitsCurrency
          account {
            id
            presignedUrl
            username
            name
          }
          organisation {
            id
            name
            presignedUrlLogo
          }
          waterfallCrest {
            id
            summary
            organisation {
              presignedUrlLogo
            }
            account {
              presignedUrl
              username
            }

          }
          waterfallParent {
            id
          }
          posts {
              id
              text
              createdAt
              accountObjectsLiked {
                id
                presignedUrl
                username
              }
              mediaObjects {
                id
                presignedUrl
              }
            }
        }
      }
    `)
      .then((result) => {
        setWaterfall(result.data.waterfall);
      })
      .catch((error) => {
        console.error("RD-4456 -- error", error);
      });
  }, [waterfallId]);

  // Highlight the current waterfall in the sausage
  useEffect(() => {
    const newValues = [...values];

    newValues.forEach((value) => {
      value.selected = value.waterfall && value.waterfall?.id === waterfall?.id;
    });

    setValues(newValues);
    return () => {
      const newValues = [...values];

      newValues.forEach((value) => {
        value.selected = false;
      });

      setValues(newValues);
    };
  }, [waterfall]);

  return (
    <div className={"flex flex-col w-full h-full gap-8 relative   "}>
      <div className="flex flex-col w-full gap-4 h-full no-scrollbar pb-24 overflow-y-scroll pt-4 px-4">
        <RaindropBackButtonPanel />

        <div className="flex xl:hidden w-full items-center justify-center">
          <RaindropCircle
            sausageValues={values}
            size={"XSMALL"}
            isRaindropPlus={userCurrent?.account?.isRaindropPlus}
            isSpringyTransition={false}
            isPaused={userCurrent?.account?.accountPlan?.isPaused}
            accountAwardFeaturedSlug={
              userCurrent?.account?.accountAwardFeatured?.award?.slug
            }
          />
        </div>

        <ContentWaterfall
          waterfall={waterfall}
          userCurrent={userCurrent}
          isYourWaterfall={isYourWaterfall}
          onAddNewOrganisation={onAddNewOrganisation}
          onCancelOrganisation={onCancelOrganisation}
          setCurrentModalComponent={setCurrentModalComponent}
          values={values}
          setValues={setValues}
        />
      </div>

      {isYourWaterfall && (
        <RaindropPinnedToBottom>
          <RaindropCard isBordered={true}>
            <FlexRow>
              <RaindropButton
                size={Size.Large}
                isFluid={true}
                title="Share"
                icon="fa-arrow-up-from-bracket"
                style={ButtonStyle.Secondary}
              />
              <RaindropButton
                size={Size.Large}
                isFluid={true}
                title="Add Post"
                style={ButtonStyle.Primary}
                icon="fa-square-plus"
                to={`/raindrop/waterfall/${waterfall?.id}/create-post`}
              />
            </FlexRow>
          </RaindropCard>
        </RaindropPinnedToBottom>
      )}

      <div />
    </div>
  );
};

export default RaindropWaterfall;
